import * as React from 'react';
import { Component } from 'react';
import styles from '../../styles/flyouts/timesheets/TimeEntryProperties.scss';
import * as _ from 'lodash';
import { withRouter } from 'react-router';
import {
  __,
  convertHoursAndMinutesToMinutes,
  convertMinutesToHoursAndMinutes,
  mapStateToProps,
  validateForm,
} from '../../core/utils';
import { setNotification } from '../../redux/actions/general/notification';
import autobind from 'autobind-decorator';
import classNames from 'classnames';
import {
  editTimesheet,
  listTimesheets,
} from '../../redux/actions/table/timesheets';
import EditTimeEntryForm from '../../forms/timesheets/EditTimeEntryForm';

@mapStateToProps((state) => ({
  auth: state.auth,
}))
@withRouter
class TimeEntryProperties extends Component {
  @autobind
  _handleSubmit(formData) {
    const { user_id } = this.props.data;

    formData = {
      ...formData,
      user_id,
      minutes: convertHoursAndMinutesToMinutes(
        formData?.hours,
        formData?.minutes,
      ),
    };

    return validateForm(
      editTimesheet(formData.id, _.omit(formData, ['id'])).then(() => {
        listTimesheets();

        // this.props.readAction(formData.id);

        setNotification(__('timesheets.properties.saved'));
      }),
    );
  }

  render() {
    const { data, collapsed } = this.props;

    const { hours, minutes } = convertMinutesToHoursAndMinutes(data?.minutes);

    return (
      <div
        className={classNames(styles.wrapper, collapsed && styles.collapsed)}
      >
        <EditTimeEntryForm
          onSubmit={this._handleSubmit}
          initialValues={{
            ..._.pick(data, [
              'description',
              'address_book_company_id',
              'is_billable',
              'date',
              'id',
              'project_id',
              'stage_id',
              'task_id',
              'substage_id',
              'substage_name',
            ]),
            minutes: minutes,
            hours: hours,
          }}
          data={data}
        />
      </div>
    );
  }
}

export default TimeEntryProperties;
